import { Component, Input } from '@angular/core';
import { Achievement } from '../models';
@Component({
  selector: 'app-strava-record',
  templateUrl: './strava-record.component.html',
  styleUrls: ['./strava-record.component.scss'],
})

export class StravaRecordComponent  {
  @Input() achievement: Achievement;
  @Input() type;
  constructor() {}

}
